/* import __COLOCATED_TEMPLATE__ from './emoji-group-buttons.hbs'; */
import Component from "@ember/component";

export default class EmojiGroupButtons extends Component {}
